module.exports = __webpack_public_path__ + "img/img.b4087cac.png";